<template>
    <div class="login-wrap" :style="`background:url(${themeImgs.loginRegBgImg})`">
        <div class="logo-box">
            <van-image :src="require('@siteResources/logo/loginReg_logo.png')" />
        </div>
        <div class="login-out-box">
            <div class="login-box">
                <van-field
                    v-model="loginParams.username"
                    :formatter="formatter"
                    clearable
                    center
                    autocomplete="off"
                    placeholder="请输入账号"
                    :left-icon="themeImgs.loginRegUserIcon"
                />
                <van-field
                    :type="inputType"
                    v-model="loginParams.password"
                    maxlength="16"
                    :formatter="formatter"
                    clearable
                    center
                    autocomplete="off"
                    placeholder="请输入密码"
                    :left-icon="themeImgs.loginRegKeyIcon"
                >
                    <template #button>
                        <span @click="changePassWordType" class="eye-icon">
                            <van-icon name="closed-eye" v-if="showEye" />
                            <van-icon name="eye-o" v-else />
                        </span>
                    </template>
                </van-field>
                <van-field
                    v-if="codeType==1 && !isNeedVerifyUserName"
                    v-model="loginParams.code"
                    maxlength="4"
                    :formatter="formatter"
                    center
                    autocomplete="off"
                    placeholder="请输入验证码"
                >
                    <template #extra>
                        <van-image class="code-img" :src="graphicCodeImg" @click="handleGetGraphicCode" />
                    </template>
                </van-field>
                <Geet ref="geetRef" id="captcha" v-show="codeType==3 && !isNeedVerifyUserName" @handleUpdateGeetStatus="handleUpdateGeetStatus" @handleGetGeetSession="handleGetGeetSession" />
                <div class="forget-box">
                    <van-checkbox name='rememberMe' v-model="isRememberMe">
                        记住密码
                    </van-checkbox>
                    <div class="service-forget" @click="setShowServicePopup(true)">联系客服</div>
                </div>
            </div>
        </div>
        <div :class="{'btns': siteName === 'qtpay'}">
            <div class="btn login-btn-box" @click="handleLogin">登录</div>
            <router-link to="/register" class="btn reg-btn-box">注册</router-link>
        </div>
        <div class="tips" v-if="siteName === 'qtpay'">
          未注册账户的用户，请先完成注册后登录
        </div>
    </div>
    <!-- 会员认证资料 -->
    <van-dialog
        v-model:show="isNeedVerifyUserName"
        title=""
        :showConfirmButton="false"
        :showCancelButton="false"
        class="login-dialog"
    >
        <div class="verify-username-box">
            <div class="code-box">
                <div class="name">会员认证资料</div>
            </div>
            <van-field
                v-model="verifyUserName"
                clearable
                center
                autocomplete="off"
                placeholder="请输入您注册时填写的真实姓名"
                :left-icon="themeImgs.loginUser"
            />
            <van-field
                v-if="codeType==1"
                v-model="loginParams.code"
                maxlength="4"
                :formatter="formatter"
                center
                autocomplete="off"
                placeholder="请输入验证码"
            >
                <template #extra>
                    <van-image class="code-img" :src="graphicCodeImg" @click="handleGetGraphicCode" />
                </template>
            </van-field>
            <Geet ref="geetRef1" id="captcha1" v-show="codeType==3" @handleUpdateGeetStatus="handleUpdateGeetStatus" @handleGetGeetSession="handleGetGeetSession" />
                
            <div class="tips">
                尊敬的会员您好：由于您的设备有变更。登录须对您会员资料进行认证。
            </div>
            <div class="btn">
                <div class="login-close" @click="handleCloseUserName">取消</div>
                <div class="login-confirm" @click="handleConfirmUserName">确认</div>
            </div>
            <div class="custom" @click="setShowServicePopup(true)" >
                <van-icon :name="themeImgs.loginKf" />
                <div>联系客服</div>
            </div>
        </div>
    </van-dialog>
</template>

<script>
import { defineComponent, ref, reactive, onBeforeMount, computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { Icon, Toast } from "vant";
import { login, getGraphicCode, getCodeType, getMaintain, getScrap, getSysDiscount } from "@/api/api";
import wsConnection from "@/utils/websocket"
import Geet from "@/components/Geet"

export default defineComponent({
    components: {
        Geet,
        [Icon.name]: Icon,
    },
    setup() {
        const $router = useRouter();
        const store = useStore();
        const geetRef = ref()
        const geetRef1 = ref()
        const siteName = ref(siteChannel)
        // 会员认证资料
        const isNeedVerifyUserName = ref(false)
        const verifyUserName = ref('')
        // 默认行为验证码状态
        const geetStatus = ref(1)
        // 改变行为验证码状态
        const handleUpdateGeetStatus = val => {
            geetStatus.value = val
        }
        // 存储验证码方式
        const codeType = ref('')
        // 获取验证码方式
        const handleGetCodeType = () => {
            getCodeType().then(res => {
                if(res.result == 200000) {
                    codeType.value = res.data.type
                    if(res.data.type==1) {
                        handleGetGraphicCode()
                    } else {
                        
                        if (isNeedVerifyUserName.value) {
                            geetRef1.value.init(res.data)
                        } else {
                            geetRef.value.init(res.data)
                        }
                        loginParams.session = res.data.session_id
                    }
                }
            })
        }
        // 获取极验证session
        const handleGetGeetSession = () => {
            handleGetCodeType()
        }
        // 存储图形验证码
        const graphicCodeImg = ref('')
        // 获取图形验证码
        const handleGetGraphicCode = () => {
            getGraphicCode().then(res => {
                if(res.result == 200000) {
                    graphicCodeImg.value = res.data.captcha
                    loginParams.session = res.data.session
                }
            })
        }

        onBeforeMount(()=> {
            handleGetCodeType()
            handleGetRemember()
        })
        // 过滤输入的中文
        const formatter = (value) => value.replace(/[\u4e00-\u9fa5]/g, "");
        const inputType = ref("password");
        const showEye = ref(true);
        const loginParams = reactive({
            username: "", //用户名
            password: "", //密码
            code: "", // 验证码
            session: "",
            is_captcha: 1
        });
        // 显示密码
        const changePassWordType = () => {
            showEye.value = !showEye.value;
            if (showEye.value) {
                inputType.value = "password";
            } else {
                inputType.value = "text";
            }
        };
        // 是否记住密码
        const isRememberMe = ref(true)
        const handleGetRemember = () => {
            if(isRememberMe.value) {
                loginParams.username = !!localStorage.getItem("username")?localStorage.getItem("username"):''
                loginParams.password = !!localStorage.getItem("password")?localStorage.getItem("password"):''
                loginParams.code = ''
                loginParams.session = ''
            } else {
                loginParams.username = ''
                loginParams.password = ''
                loginParams.code = ''
                loginParams.session = ''
            }

        }

        // 获取系统优惠
        const handleGetSysDiscount = () => {
            getSysDiscount().then(res => {
                if(res.result == 200000) {
                    store.dispatch('saveSysDiscountActions', res.data.data)
                }
            })
        }
        // 点击登录
        const handleLogin = () => {
            console.log(loginParams);
            console.log(codeType.value, geetStatus.value);
            if (!loginParams.username) {
                return Toast.fail("请输入手机号码/邮箱");
            } else if (!loginParams.password) {
                return Toast.fail("请输入密码");
            } else if (codeType.value==1 && !loginParams.code) {
                return Toast.fail("请输入验证码");
            } else if (codeType.value==3 && geetStatus.value!=4) {
                return Toast.fail("请点击进行验证");
            } else {
                login(loginParams).then((res) => {
                    if (res.result == 200000) {
                        getScrap()
                        // 在请求一次public
                        if (siteName.value == 'qpay') {
                            handleGetSysDiscount()
                        }
                        Toast.success("登录成功");
                        store.dispatch("saveLoginInfosActions", res.data);
                        $router.push("/home");
                        wsConnection.initWebSocket()
                        isNeedVerifyUserName.value = false
                        if(isRememberMe.value) {
                            localStorage.setItem("rememberMe", isRememberMe.value);
                            localStorage.setItem("username", loginParams.username);
                            localStorage.setItem("password", loginParams.password);
                        } else {
                            localStorage.removeItem("username");
                            localStorage.removeItem("password");
                            localStorage.removeItem("rememberMe");
                        }
                    } else {
                        if(codeType.value==3) {
                            handleGetCodeType()
                        } else {
                            handleGetGraphicCode()
                        }
                        loginParams.code = ''
                       
                        Toast.fail(res.msg)
                        // console.log(res)
                        if ((res.result === 101118 || res.result === 101119) && siteName.value === 'qtpay') {
                            // 需要添加二次验证
                            loginParams.name = ''
                            verifyUserName.value = ''
                            isNeedVerifyUserName.value = true
                        }
                    }
                }).catch(err=>{
                    console.log(err);
                })
            }
        }
        // 是否显示用户名或手机号/邮箱登录结构
        const showUsernameLogin = ref(true)
        // mapstate--皮肤对应的图片
        const themeImgs = computed(() => store.state.themeImgs)

        const setShowServicePopup = (flag) => {
            store.commit('setShowServicePopup', flag)
        }
        // 会员认证资料关闭
        const handleCloseUserName = () => {
            isNeedVerifyUserName.value = false
            loginParams.name = ''
            verifyUserName.value = ''
            if(codeType.value==3) {
                handleGetCodeType()
            }
        }
        // 会员认证资料确认
        const handleConfirmUserName = () => {
            if(!verifyUserName.value) {
                return Toast.fail('请输入真实姓名')
            }
            
            loginParams.name = verifyUserName.value
            handleLogin()
        }


        return {
            isNeedVerifyUserName,
            verifyUserName,
            handleCloseUserName,
            handleConfirmUserName,
            siteName,
            codeType,
            graphicCodeImg,
            handleGetGraphicCode,
            formatter,
            inputType,
            showEye,
            loginParams,
            changePassWordType,
            isRememberMe,
            handleLogin,
            geetStatus,
            handleUpdateGeetStatus,
            geetRef,
            geetRef1,
            handleGetGeetSession,
            showUsernameLogin,
            themeImgs,
            setShowServicePopup
        };
    },
});
</script>

<style lang="less" scoped>
.login-wrap {
    min-height: 100vh;
    padding: 0 25px;
    background-repeat: no-repeat !important;
    background-size: 100% 100% !important;
    .logo-box {
        position: relative;
        text-align: center;
        .van-image {
            width: 168px;
            margin-top: 38px;
        }
    }
    .login-out-box {
        padding: 40px 15px;
        background: var(--outBoxBgColor);
        box-shadow: var(--outBoxShadow);
        border-radius: 30px;
        .login-box {
            :deep(.van-cell) {
                margin-bottom: 8px;
                padding-left: 5px;
                background: inherit;
                border-bottom: 1px solid rgba(255, 255, 255, 0.2);
                .van-field__control {
                    color: var(--logRegInputTextColor);
                }
                :deep(.van-field__left-icon) {
                    width: 24px;
                    height: 24px;
                    .van-icon__image {
                        width: 24px;
                        height: 24px;
                    }
                }
                :deep(.code-img) {
                    position: absolute;
                    top: 0;
                    right: 0;
                    width: 100px;
                    height: 45px;
                }
                &::after {
                    border: none;
                }
                input::-webkit-input-placeholder {
                    color: var(--logRegPlaceholderColor);
                }
                input:-ms-input-placeholder {
                    color: var(--logRegPlaceholderColor);
                }
                input:-moz-placeholder {
                    color: var(--logRegPlaceholderColor);
                    opacity: 1;
                }
                input::-moz-placeholder {
                    color: var(--logRegPlaceholderColor);
                    opacity: 1;
                }
                .eye-icon {
                    font-size: 18px;
                    color: var(--logRegEyeIconColor);
                }
            }
            .forget-box {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 15px;
                .service-forget {
                    font-size: 14px;
                    letter-spacing: 0.5px;
                    color: var(--forgetTextColor);
                }
            }
        }
    }
    .btns {
        display: flex;
        gap: 10px;
    }
    .btn {
        width: 100%;
        height: 45px;
        margin-top: 24px;
        line-height: 45px;
        text-align: center;
        font-weight: 600;
        letter-spacing: 0.5px;
        border-radius: 41px;
        &.login-btn-box {
            background: var(--logRegBtnBgColor);
            color: var(--textColor1);
        }
        &.reg-btn-box {
            display: block;
            color: #fff;
            border: 2px solid var(--borderColor);
        }
    }
    .tips {
        text-align: center;
        margin-top: 10px;
        font-size: 14px;
        font-weight: 800;
    }
}
</style>
<style lang="less">
.login-dialog {
    background: var(--headBgColor) !important;
    .verify-username-box {
        padding: 24px;
        .code-box {
            text-align: center;
            margin-bottom: 40px;
            .name {
                font-size: 18px;
                font-weight: 600;
                color: #000;
            }
        }
        .van-field {
            margin-bottom: 20px;
            padding-left: 5px;
            background: #E8F3FB !important;
            border-radius: 8px !important;
            .van-field__control {
                color: #00000099;
            }
            .van-field__left-icon {
                width: 24px;
                height: 24px;
                .van-icon__image {
                    width: 24px;
                    height: 24px;
                }
            }
            &::after {
                border: none;
            }
            input::-webkit-input-placeholder {
                color: #9D9D9D;
            }
            input:-ms-input-placeholder {
                color: #9D9D9D;
            }
            input:-moz-placeholder {
                color: #9D9D9D;
                opacity: 1;
            }
            input::-moz-placeholder {
                color: #9D9D9D;
                opacity: 1;
            }
            .code-img {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                right: 4px;
                width: 100px;
                height: 35px;
            }
        }
        .tips {
            margin-top: 20px;
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 12px;
            line-height: 20px;
            color: #F50000;
        }
        .btn {
            height: 40px;
            line-height: 40px;
            font-size: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 20px;
            margin-top: 40px;
            box-sizing: border-box;
            .login-close {
                flex: 1;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
                border: 1px solid var(--outBoxBgColor);
                color: var(--outBoxBgColor);
                border-radius: 4px;
            }
           .login-confirm {
                flex: 1;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: var(--btnBgColor);
                color: #fff;
                border-radius: 4px;
            }
        }
    }
    .custom {
        margin-top: 30px;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;
        font-size: 14px;
        color: var(--outBoxBgColor);
        img {
            width: 20px;
            height: 20px;
        }
    }
}
</style>
